import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import SearchComponent from "../Search";
import { useDebounce } from "../../Global/Hooks/useDebounce";
import useGetAccountApi from "../../Global/Api/Account/getAccountApi";
import useSetProvidersApi from "../../Global/Api/Signup/setProvidersApi";
import {
  useGetProvidersQuery,
  useLazyGetCustomerAppQrCodeQuery,
  useLogoutMutation,
} from "../../Store/Builder/techsbook.api";
import "./index.scss";
import showToast from "../../Global/Hooks/toast";

export default function NavBar({ socket }) {
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  const location = useLocation();
  const navigate = useNavigate();
  const changeProviderApi = useSetProvidersApi();
  const [showProviders, setShowProviders] = useState(false);
  const [showDrop, setShowDrop] = useState(false);
  const [imagePath, setImagePath] = useState("./");
  const [checkPath, setCheckPath] = useState(false);
  const [enProviders, setEnProviders] = useState([]);
  const [disProviders, setDisProviders] = useState([]);
  const [providerType, setProviderType] = useState('enabled')
  const [search, setSearch] = useState("");
  const [filteredDisProviders, setFilteredDisProviders] = useState([]);
  const [showQR, setShowQR] = useState(true);
  const [qrCodeImage, setQrCodeImage] = useState("");

  // const debouncedSearchValue = useDebounce(search, 300);

  const { totalUnreadMessage } = useSelector(
    (state) => state?.rootReducer.messagingSlice
  );
  const { get } = useGetAccountApi();
  const { data } = useGetProvidersQuery();
  const [getCustomerAppQrCode] = useLazyGetCustomerAppQrCodeQuery();

  useEffect(() => {
    if(accountIndex === null) {
      get()
    }
  }, []);

  useEffect(() => {
    getCustomerAppQrCode()
      .unwrap()
      .then((res) => {
        if (res?.qr_code_url) {
          setQrCodeImage(res.qr_code_url);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    return window.addEventListener("click", (e) => {
      if (
        e.target.closest(".nav__drop") === null &&
        e.target.closest(".nav__profile") === null
      ) {
        setShowDrop(false);
      }
    });
  }, [location]);

  useEffect(() => {
    if (
      location.pathname === "/settings/personal-info" ||
      location.pathname === "/settings/security" ||
      location.pathname === "/settings/providers" ||
      location.pathname === "/settings/locations" ||
      location.pathname === "/settings/payment-method" ||
      location.pathname === "/settings/faq"
    ) {
      setImagePath("../../");
      setCheckPath(true);
    } else if (location.pathname === `/jobs/${localStorage.getItem("jobId")}`) {
      setImagePath("../../");
    } else {
      setImagePath("./");
      setCheckPath(false);
    }
  }, [location]);

  useEffect(() => {
    setSearch('');

    const enabledProviders = data?.filter(el => el.stripe_enabled);
    setEnProviders(enabledProviders);

    const disabledProviders = data?.filter(el => !el.stripe_enabled);
    setDisProviders(disabledProviders);
    setFilteredDisProviders(disabledProviders);
  }, [showProviders]);

  const [logoutRequest] = useLogoutMutation();

  const logout = async () => {
      await logoutRequest().then((res) => {
          localStorage.removeItem('techsbook_customer_portal_token');
          navigate("/login");
          showToast(res.data?.message,  'success');
      }).catch((e) => {
          showToast(e?.data?.message || e, 'error');
      });
  };

  const openProviders = () => {
    setShowProviders(true);
  };

  const closeProviders = () => {
    setShowProviders(false);
  };

  const selectProvider = (provider) => {
    closeProviders();
    setProviderType('enabled');
    changeProviderApi.send({ provider_id: provider?.id });
  };

  const openDisabledProviders = (text) => {
    setProviderType(text);
  };

  const handleNavClick = () => {
    setShowProviders(false);
  };

  const handleSearch = (searchTerm) => {
    setSearch(searchTerm);
  };

  useEffect(() => {
    if (search) {
      const filtered = disProviders.filter(el => 
        el.name.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredDisProviders(filtered);
    } else {
      setFilteredDisProviders(disProviders);
    }
  }, [search, disProviders]);
  
  const SelectDisabledProviderSection = () => {
    return (
      <div className={!showProviders ? 'closed-select-provider' : 'select-provider'}>
        <div className="select-provider__container">
          <div className="select-provider__head disabled-list">
              <img 
                src={`${"/assets/icons/switch-icon-dark.svg"}`} 
                alt="" 
                onClick={() => openDisabledProviders('enabled')}
                className="arrow-icon-transform"/>
            <p>{accountIndex?.business_unit_name}</p>
          </div>

          <div className="select-provider__search">
              <SearchComponent
                searchTerm={search}
                onSearch={handleSearch}
                placeholder="Search provider"
              />
            </div>
          <div className="select-provider__providers">
            
            {
              filteredDisProviders?.map((el, idx) => (
                <div 
                  key={idx} 
                  onClick={() => selectProvider(el)}
                  className="select-provider__providers__provider">
                  <div className="select-provider__providers__provider-left">
                    <div className="provider-logo">
                      <img src={el?.thumbnail} alt="logo" />
                    </div>
                    <span>{el?.name}</span>
                  </div>
                  <div className="select-provider__providers__provider-right">
                    {el?.id === accountIndex?.provider_id ? (
                      <img alt="#" src={`${"/assets/icons/selected-provider.svg"}`} className="selectProviderIcon"/>
                    ) : ''}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
  )
  };

  const SelectProviderSection = () => {
    return (
        <div className={!showProviders ? 'closed-select-provider' : 'select-provider'}>
          <div className="select-provider__container">
            <div className="select-provider__head">
              <p>Select provider</p>
                  <img src="/assets/icons/close.svg" alt="close" onClick={closeProviders}/>
            </div>

            <div className="select-provider__providers">
              <div 
                onClick={() => openDisabledProviders('disabled')}
                className="select-provider__providers__provider">
                <div className="select-provider__providers__provider-left">
                  <div className="provider-logo">
                    <img src="/favicon.png" alt="" />
                  </div>
                  <span>{accountIndex?.business_unit_name}</span>
                </div>
                <img 
                  src={`${"/assets/icons/switch-icon-dark.svg"}`} 
                  alt="" 
                  className="arrow-icon"/>
              </div>

              {
                enProviders?.map((el, idx) => (
                  <div 
                    key={idx} 
                    onClick={() => selectProvider(el)}
                    className="select-provider__providers__provider">
                    <div className="select-provider__providers__provider-left">
                      <div className="provider-logo">
                      <img src={el?.thumbnail} alt="logo" />
                      </div>
                      <span>{el?.name}</span>
                    </div>
                    <div className="select-provider__providers__provider-right">
                    {el?.id === accountIndex?.provider_id ? (
                      <img alt="#" src={`${"/assets/icons/selected-provider.svg"}`} className="selectProviderIcon"/>
                    ) : ''}
                  </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
    )
  };

  return (
    <>
       <div className="nav">
        <div className="nav__top">
          <div className="nav__logo">
            <img src={`${"/assets/images/nav-logo.svg"}`} alt="techsbook" />
          </div>

          <div className="nav__provider">
            <div className="nav__provider__item" onClick={openProviders}>
              <div className="nav__provider__item-logo">
                <div className="item-logo">
                  <img src={data?.find((el) => el?.id === accountIndex?.provider_id)?.thumbnail} alt="" />
                </div>
                <span>{data?.find((el) => el?.id === accountIndex?.provider_id)?.name}</span>
              </div>
              <img src={`${"/assets/icons/switch-icon.svg"}`} alt="" className="arrow-icon"/>
            </div>
          </div>

          <div className="nav__items">
            <NavLink
              to="/"
              onClick={handleNavClick}
              className={`nav__item ${location.pathname === "/" ? "nav__item_active" : ""}`}
            >
              <div className="nav__item-left">
                <span>
                  <img
                    src={`${
                      location.pathname === "/"
                        ? "/assets/icons/technicians-white.svg"
                        : "/assets/icons/technicians.svg"
                    }`}
                    alt="technicians"
                  />
                </span>
                <p className="nav__item-text">Technicians</p>
              </div>
            </NavLink>
            <NavLink
              to="/jobs"
              onClick={handleNavClick}
              className={`nav__item ${
                location.pathname === "/jobs" ? "nav__item_active" : ""
              }`}
            >
              <div className="nav__item-left">
                <span>
                  <img
                    src={`${
                      location.pathname === "/jobs" ||
                      location.pathname ===
                        `/jobs/${localStorage.getItem("jobId")}`
                        ? "/assets/icons/jobs-white.svg"
                        : "/assets/icons/jobs.svg"
                    }`}
                    alt="jobs"
                  />
                </span>
                <p className="nav__item-text">Jobs</p>
              </div>
            </NavLink>
            <NavLink
              to="/messaging"
              onClick={handleNavClick}
              className={`nav__item ${
                location.pathname === "/messaging" ? "nav__item_active" : ""
              }`}
            >
              <div className="nav__item-left">
                <span>
                  <img
                    src={`${
                      location.pathname === "/messaging"
                        ? "/assets/icons/messaging-white.svg"
                        : "/assets/icons/messaging.svg"
                    }`}
                    alt="messaging"
                  />
                </span>
                <p className="nav__item-text">Messaging</p>
              </div>
              {totalUnreadMessage > 0 && (
                <span className="nav__item-count">{totalUnreadMessage}</span>
              )}
            </NavLink>
            {
              accountIndex?.show_vehicle_forms ? (
                <NavLink
                  to="/vehicles"
                  onClick={handleNavClick}
                  className={`nav__item ${
                    location.pathname === "/vehicles" ? "nav__item_active" : ""
                  }`}
                >
                  <div className="nav__item-left">
                    <span>
                      <img
                        src={`${
                          location.pathname === "/vehicles"
                            ? "/assets/icons/vehicles-white.svg"
                            : "/assets/icons/vehicles.svg"
                        }`}
                        alt="vehicles"
                      />
                    </span>
                    <p className="nav__item-text">My vehicles</p>
                  </div>
                </NavLink>
              ) : ''
            }
            
            <NavLink
              to="/settings"
              onClick={handleNavClick}
              className={`nav__item ${
                location.pathname === "/settings" ? "nav__item_active" : ""
              }`}
            >
              <div className="nav__item-left">
                <span>
                  <img
                    src={`${
                      location.pathname === "/settings" || checkPath
                        ? "/assets/icons/settings-white.svg"
                        : "/assets/icons/settings.svg"
                    }`}
                    alt="settings"
                  />
                </span>
                <p className="nav__item-text">Settings</p>
              </div>
            </NavLink>
          </div>

          {
            showQR ? (
                <div className="nav__qr">
                  <div className="nav__qr_head">
                    <h2>Get the App!</h2>
                    <img
                        src="/assets/icons/close.svg"
                        alt="close"
                        onClick={() => setShowQR(false)}
                    />
                  </div>
                  <p className="nav__qr_desc">Messages & scheduling on the go</p>
                  <div className="nav__qr_self">
                    <img src={qrCodeImage} alt="app qr code"/>
                  </div>
                  <p className="nav__qr_desc center">iOS & Android</p>
                </div>
            ) : null
          }
        </div>
        {showDrop && (
          <div className={`nav__drop ${showDrop ? "nav__drop_active" : ""}`}>
            <div
              onClick={async () => logout()}
              className="nav__drop-item"
            >
              <span>
                <img src={`${"/assets/icons/logout.svg"}`} alt="logout" />
              </span>
              <p className="nav__drop-text">Log Out</p>
            </div>
          </div>
        )}
        <div
          onClick={() => {
            setShowDrop(!showDrop);
          }}
          className="nav__profile"
        >
          <div className="nav__profile-left">
            <div
              className={`nav__profile-avatar
              `}
            >
              <img
                src={`${
                  accountIndex?.image
                    ? accountIndex?.image
                    : "/assets/icons/user-example.svg"
                }`}
                alt="avatar"
              />
            </div>
            <p className="nav__profile-name">
              {(accountIndex?.company_name ?? "--- ----")}
            </p>
          </div>
          <span>
            <img src="/assets/icons/nav-arrow.svg" alt="arrows" />
          </span>
        </div>
      </div>
      {providerType === 'disabled' ? <SelectDisabledProviderSection /> : <SelectProviderSection />}
    </>
  );
}
